<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';

import type { AppTransitionTimeType, AppFadeTransitionType } from '../model';

interface AppFadeTransitionProps {
  transitionTime?: AppTransitionTimeType;
  transitionType?: AppFadeTransitionType;
}

const props = withDefaults(defineProps<AppFadeTransitionProps>(), {
  transitionTime: 'medium',
  transitionType: 'fade-in-out',
});

const transitionName = computed(
  () => `transition-${props.transitionType}-${props.transitionTime}`
);

const isVisible = ref<boolean>(false);

onMounted(() => {
  isVisible.value = true;
});
</script>

<template>
  <Transition :name="transitionName">
    <slot v-if="isVisible" />
  </Transition>
</template>

<style scoped lang="scss">
$durations: (
  very-short: var(--transition-very-short),
  short: var(--transition-short),
  medium: var(--transition-medium),
  long: var(--transition-long),
  very-long: var(--transition-very-long),
);

@each $time, $duration in $durations {
  .transition-fade-in-#{$time}-enter-active {
    transition: opacity #{$duration};
  }
  .transition-fade-in-#{$time}-enter-from {
    opacity: 0;
  }

  .transition-fade-out-#{$time}-leave-active {
    transition: opacity #{$duration};
  }
  .transition-fade-out-#{$time}-leave-to {
    opacity: 0;
  }

  .transition-fade-in-out-#{$time}-enter-active,
  .transition-fade-in-out-#{$time}-leave-active {
    transition: opacity #{$duration};
  }
  .transition-fade-in-out-#{$time}-enter-from,
  .transition-fade-in-out-#{$time}-leave-to {
    opacity: 0;
  }
}
</style>
